module.exports = __webpack_public_path__ + "img/icon-map-pin.b9065d36.svg";